import axios from 'axios'
import { bookingUrls } from '../urls'

export default {
  post_new_school (context, data) {
    axios.post(bookingUrls.addNewSchool, data).then(() => {
      context.dispatch('fetch_all_schools')
    })
  },
  fetch_all_schools (context) {
    axios.get(bookingUrls.fetchAllSchools).then(function (response) {
      context.commit('ALL_SCHOOLS', response.data)
    })
  },
  delete_school (context, data) {
    axios.patch(bookingUrls.deleteSchool, data).then(() => {
      context.dispatch("fetch_all_schools")
    })
  },
  update_school (context, data) {
    return new Promise((resolve, reject) => {
      axios.patch(bookingUrls.updateSchool, data)
        .then((response) => {
          context.dispatch('fetch_all_schools')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

}
